export default __webpack_public_path__ + "static/media/ghost.18d2b0e6.jpeg";